import utils from 'utils';
import EnquiryListingContext from '../providers/EnquiryListing';
import { useContext, useMemo } from 'react';
import { useLocation, Location } from 'react-router-dom';
import { OPEN_ENQUIRY_HASH } from 'data/global';

export default function useEnquiryReroute() {
  const { listing } = useContext(EnquiryListingContext);

  const { pathname, search } = useLocation();

  const {
    _id: listingId,
    industry,
    slugName,
    type,
    enableTeaser,
  } = listing || {};

  const redirectionListingLink = useMemo(
    () => utils.composeBusinessUrl(industry, slugName, type),
    [industry, slugName, type],
  );

  const redirect = useMemo(
    () =>
      enableTeaser
        ? `${redirectionListingLink}/teaser`
        : `${pathname + search}${OPEN_ENQUIRY_HASH}`,
    [enableTeaser, pathname, redirectionListingLink, search],
  );

  const location = useMemo(
    () => ({ pathname: redirect, state: { id: listingId } } as Location),
    [listingId, redirect],
  );

  return location;
}
